export default Object.freeze({
    roles: [
        {
            name: "sysadmin",
            description: "System Administrator",
            ability: [{ action: "manage", subject: "all" }],
        },
        {
            name: "cc-recruitment-admin",
            description: "CoActive Care - Recruitment Admin",
            appGroup: "admin-recruitment",
            ability: [
                { action: "access", subject: "app.recruitment" },
                { action: "manage", subject: "app.recruitment.job-opportunities" },
                { action: "manage", subject: "app.recruitment.job-applications" },
                { action: "manage", subject: "app.recruitment.job-templates" },
                { action: "manage", subject: "app.recruitment.users" },
                { action: "manage", subject: "app.recruitment.settings" },
                { action: "manage", subject: "app.recruitment.job-offers" },
            ],
        },
        {
            name: "cc-rota-admin",
            description: "CoActive Care - Rota Admin",
            appGroup: "rota",
            ability: [
                { action: "access", subject: "rota" },
                { action: "manage", subject: "clients" },
                { action: "manage", subject: "rota.rotas" },
                { action: "manage", subject: "rota.rota-users" },
                { action: "manage", subject: "rota.rota-agencies" },
                { action: "manage", subject: "rota.rota-oncall" },
                { action: "manage", subject: "rota.rota-activities" },
                { action: "manage", subject: "rota.rota-reporting" },
            ],
        },
        {
            name: "cc-rota-user",
            description: "CoActive Care - Rota User",
            appGroup: "rota",
            ability: [
                { action: "access", subject: "rota" },
                { action: "read", subject: "clients" },
                { action: "read", subject: "rota.rotas" },
                { action: "self-assign", subject: "rota.rotas" },
                { action: "read", subject: "rota.rota-users" },
                { action: "read", subject: "rota.rota-agencies" },
                { action: "read", subject: "rota.rota-oncall" },
                { action: "read", subject: "rota.rota-activities" },
                { action: "create", subject: "rota.rota-activities" },
                { action: "update", subject: "rota.rota-activities" },
                { action: "delete", subject: "rota.rota-activities" },
            ],
        },
        {
            name: "cc-rota-agency",
            description: "CoActive Care - Rota Agency Worker",
            // cannot be assigned to the user via the UI
            hideFromUI: true,
            appGroup: "rota",
            ability: [
                { action: "access", subject: "rota" },
                { action: "read", subject: "clients" },
                { action: "read", subject: "rota.rotas" },
                { action: "read", subject: "rota.rota-users" },
                { action: "read", subject: "rota.rota-agencies" },
                { action: "read", subject: "rota.rota-oncall" },
                { action: "read", subject: "rota.rota-activities" },
                { action: "update", subject: "rota.rota-activities" },
            ],
        },
        {
            name: "cc-chat-admin",
            description: "CoActive Care - Chat Admin",
            appGroup: "chat",
            ability: [
                { action: "access", subject: "messaging" },
                { action: "manage", subject: "messaging.channels" },
                { action: "manage", subject: "messaging.messages" },
            ],
        },
        {
            name: "cc-chat-user",
            description: "CoActive Care - Chat User",
            appGroup: "chat",
            ability: [
                { action: "access", subject: "messaging" },
                { action: "read", subject: "messaging.channels" },
                { action: "read", subject: "messaging.messages" },
                { action: "create", subject: "messaging.messages" },
                { action: "update", subject: "messaging.messages" },
            ],
        },
    ],
    apps: [
        {
            id: "admin-recruitment",
            name: "Recruitment Admin",
            abilityAction: "access",
            abilitySubject: "app.recruitment",
            icon: "hand-holding-heart",
        },
        {
            id: "rota",
            name: "Rota",
            abilityAction: "access",
            abilitySubject: "rota",
            icon: "calendar-alt",
        },
        {
            id: "chat",
            name: "Chat",
            abilityAction: "access",
            abilitySubject: "messaging",
            icon: "comment",
        },
    ],
    newUserDefaultRoles: ["cc-rota-user", "cc-chat-user"],
    newAgencyUserDefaultRoles: ["cc-rota-agency", "cc-chat-user"],
});
//# sourceMappingURL=constants.js.map